export const GET_LICENSES = (userSeq: number): string => `
    query {
        getLicenses(userSeq: ${userSeq}) {
            types
        }
    }
`;

export const GET_LICENSE_TYPES = `
    query {
        getLicenseTypes {
            type
            name
        }
    }
`;

export const GET_LICENSE_HISTORY = (type: number) => `
    query {
        getLicenseHistory(type: ${type}) {
            totalCount
            licenseType
            histories {
                count
                date
            }
        }
    }
`;

export const GET_LICENSE_USERS = (page: number, userTypes: number[], licenseTypes: number[], keywordType: number, keyword: string) => `
    query {
        getLicenseUsers(page: ${page}, userTypes: [${userTypes}], licenseTypes: [${licenseTypes}], keywordType: ${keywordType}, keyword: "${keyword}") {
            totalPage
            totalItems
            currentPage
            items {
                seq
                type
                name
                email
                companyName
                businessNumber
                companyType
                licenses
            }
        }
    }
`;

export const GET_USER_LICENSES = (userSeq: number) => `
    query {
        getUserLicenses(userSeq: ${userSeq}) {
            licenses {
                subscriptionSeq
                licenseCode
                isActive
                isSubscribing
                startAt
                nextRenewalAt
            }
        }
    }
`;

export const GET_CAPACITY = (userSeq: number, type: number) => `
    query {
        getCapacityInfo(userSeq: ${userSeq}, type: ${type}) {
            capacity
            count
        }
    }
`;